<div
  *ngIf="entry?.removed !== 'removed'"
>
    <ng-container *ngIf="isFirstOrderEntryInContract(entry)">
      <div
        *ngIf="componentTexts?.infoBar?.length"
        class="udex-mb-4" data-cy="dcp-info-bar"
      >
      <udex-message-strip
          class="udex-px-20 udex-pt-20"
          design="Information"
          status-type="Icon"
          hide-close-button
        >
        <ng-container
          *ngIf="transactionTypeTexts?.thankYouInfoMessage1 && transactionTypeTexts?.thankYouInfoMessage2; else infoBarTxt"
        >
          <p class="body--s">
            {{transactionTypeTexts?.thankYouInfoMessage1}}
            {{entry?.product?.vendor?.address?.companyName}}
            {{transactionTypeTexts?.thankYouInfoMessage2}}
          </p>
        </ng-container>
        <ng-template #infoBarTxt>
          <p class="body--s">{{componentTexts?.infoBar}}</p>
        </ng-template>
      </udex-message-strip>
      </div>
    </ng-container>
    <dcp-checkout-licenses
      [cartEntry]="entry"
      [collapsed]="collapsed"
      [collapsable]="collapsable && !isInvalid"
      [derivativeCount]="derivativeCount"
      [isInvalid]="isInvalid"
      [showPrice]="showPrice"
      [showRemoveAction]="showRemoveAction"
      [showEditAction]="showEditAction"
      [componentTexts]="componentTexts"
    ></dcp-checkout-licenses>
  <ng-content></ng-content>
</div>
<dcp-remove-product-success-message
  *ngIf="entry?.removed === 'removed' && entryCount > 1"
  [orderEntry]="entry">
</dcp-remove-product-success-message>
